import { useCallback } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, Typography } from '@customink/pigment-react';
import Spinner from '~/components/Spinner';
import { useAddressDelete } from '~/adapters/services/accounts/postalAddresses/hooks';
import { EmptyFunction } from '~/adapters/typescript/emptyFunction';

interface DeleteDialogProps {
    id: number;
    open: boolean;
    onClose: EmptyFunction;
}

export function DeleteDialog({ id, open, onClose }: DeleteDialogProps) {
    const { mutate, isLoading } = useAddressDelete();
    const handleRemoveAddress = useCallback(() => mutate({ id }, { onSettled: onClose }), [id, mutate]);

    return (
        <Dialog title="Remove This Address" open={open} onClose={onClose}>
            <DialogContent>
                <Alert severity="error" sx={{ mb: 3 }}>
                    <Typography variant="bodyLong1">This address will be removed from your account.</Typography>
                </Alert>
                <Typography variant="bodyLong1">
                    You will no longer be able to reuse this address during checkout.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="secondary">
                    Cancel
                </Button>
                <Button onClick={handleRemoveAddress} variant="primary" disabled={isLoading}>
                    {isLoading ? <Spinner /> : 'Remove'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
